<div class="facility-details-view-container" *ngIf="facilityObject" fxLayout="column" fxLayoutGap="15px">
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="facilityObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).facility.write" (click)="modify()" mat-stroked-button
            color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).facility.delete" (click)="delete()" mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span></button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxLayoutGap="15px">
        <div fxFlex="100">
          <app-detail-address header="Adres placówki" [address]="facilityObject.address"></app-detail-address>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"
           *ngIf="((userPermissions | async).dobry_agent.read) && hasPartnerTag(facilityObject, PARTNER_TAGS_GOOD_AGENT) && (this.userApplicationPermission | async).dobryagent.active">
        <div fxFlex="100">
          <mat-card>
            <h3>Wizytówka DobryAgent.pl</h3>
            <div fxLayout="column" fxLayoutGap="15px">

              <app-detail fxFlex="100" header="Status" [loading]="loadingFacilityDobryAgent">
                {{ facilityDobryAgentObject?.status?.name }}
              </app-detail>
              <app-detail fxFlex="100" header="Placówka DobryAgent" [loading]="loadingFacilityDobryAgent">
                {{ facilityDobryAgentObject?.name }}
              </app-detail>
              <app-detail fxFlex="100" header="Link do placówki" [loading]="loadingFacilityDobryAgent">
                <a class="default-link" [href]="facilityDobryAgentObject?.url"
                   target="_blank">{{ facilityDobryAgentObject?.url }}</a>
              </app-detail>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="facilityObject.note"></app-detail>
              </div>

            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer terminala"
                            [value]="facilityObject.terminalNumber">
                </app-detail>
              </div>
            </div>

            <div fxLayout="column" *ngFor="let partner of facilityObject.partners">
              <div fxFlex="100">
                <app-detail header="Partner"
                            [link]="['/partnerzy/szczegoly', partner.uuid]"
                            [value]="partner.shortName">
                </app-detail>
              </div>
              <div fxFlex="100">
                <app-detail header="Tagi">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of partner.tags; let last = last">
                      <mat-chip color="accent" selected>{{ tag.name }}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="facilityObject.facilityType">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Typ placówki</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Typ placówki" [value]="facilityObject.facilityType.name"></app-detail>
              </div>

            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="!profitFacility">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Weryfikacja procesu sprzedaży</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail-bool header="Przeprowadzona kontrola"
                                 [value]="facilityObject.inspectionCarried"></app-detail-bool>
              </div>

            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="profitFacility">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Profitowi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Dyrektor struktury"
                            [link]="facilityObject.structureDirector ? ['/ofwca/szczegoly', facilityObject.structureDirector.uuid] : undefined"
                            [value]="facilityObject.structureDirector?.fullName">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Wicedyrektor"
                            [link]="facilityObject.assistantDirector ? ['/ofwca/szczegoly', facilityObject.assistantDirector.uuid] : undefined"
                            [value]="facilityObject.assistantDirector?.fullName">
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Dyrektor regionalny"
                            [link]="facilityObject.regional ? ['/ofwca/szczegoly', facilityObject.regional.uuid] : undefined"
                            [value]="facilityObject.regional?.fullName">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
